/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Section_05_DescInputs */

const en_landing_section_05_desc = /** @type {(inputs: Landing_Section_05_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five steps. Review tailored materials before you submit.`)
};

const de_landing_section_05_desc = /** @type {(inputs: Landing_Section_05_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fünf Schritte. Null manuelles Formatieren. Dein Lebenslauf durchläuft unsere KI-Pipeline und kommt ATS-optimiert heraus.`)
};

const fr_landing_section_05_desc = /** @type {(inputs: Landing_Section_05_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five steps. Zero manual formatting. Your resume goes through our AI pipeline and comes out ATS-ready.`)
};

const es_landing_section_05_desc = /** @type {(inputs: Landing_Section_05_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five steps. Zero manual formatting. Your resume goes through our AI pipeline and comes out ATS-ready.`)
};

const it_landing_section_05_desc = /** @type {(inputs: Landing_Section_05_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five steps. Zero manual formatting. Your resume goes through our AI pipeline and comes out ATS-ready.`)
};

const nl_landing_section_05_desc = /** @type {(inputs: Landing_Section_05_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five steps. Zero manual formatting. Your resume goes through our AI pipeline and comes out ATS-ready.`)
};

const pl_landing_section_05_desc = /** @type {(inputs: Landing_Section_05_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five steps. Zero manual formatting. Your resume goes through our AI pipeline and comes out ATS-ready.`)
};

const fi_landing_section_05_desc = /** @type {(inputs: Landing_Section_05_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five steps. Zero manual formatting. Your resume goes through our AI pipeline and comes out ATS-ready.`)
};

const da_landing_section_05_desc = /** @type {(inputs: Landing_Section_05_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five steps. Zero manual formatting. Your resume goes through our AI pipeline and comes out ATS-ready.`)
};

const sv_landing_section_05_desc = /** @type {(inputs: Landing_Section_05_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five steps. Zero manual formatting. Your resume goes through our AI pipeline and comes out ATS-ready.`)
};

/**
* | output |
* | --- |
* | "Five steps. Review tailored materials before you submit." |
*
* @param {Landing_Section_05_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_section_05_desc = /** @type {((inputs?: Landing_Section_05_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Section_05_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_section_05_desc(inputs)
	if (locale === "fr") return fr_landing_section_05_desc(inputs)
	if (locale === "es") return es_landing_section_05_desc(inputs)
	if (locale === "it") return it_landing_section_05_desc(inputs)
	if (locale === "nl") return nl_landing_section_05_desc(inputs)
	if (locale === "pl") return pl_landing_section_05_desc(inputs)
	if (locale === "fi") return fi_landing_section_05_desc(inputs)
	if (locale === "da") return da_landing_section_05_desc(inputs)
	if (locale === "sv") return sv_landing_section_05_desc(inputs)
	return en_landing_section_05_desc(inputs)
});